import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@/common/components/link';
import { MobileAppButtons } from '@/common/components/mobile-app-buttons';
import { Phototron } from '@/common/components/phototron';
import { EXPLORE_URL, FOOTER_LINK } from '@/common/constants';
import { styles } from './styles';

export const VoucherRedeemSubscriptionSuccessPage: FC = () => {
  const [t] = useTranslation();

  return (
    <div css={styles}>
      <Phototron />

      <h2 className='title'>{t('page.subscriptionSuccess.title')}</h2>

      <div className='description'>{t('page.subscriptionSuccess.paragraph1')}</div>
      <div className='description'>{t('page.subscriptionSuccess.paragraph2')}</div>
      <div className='description'>
        {t('page.subscriptionSuccess.paragraph3')}
        <Link className='link' target='_blank' href={EXPLORE_URL}>
          {t('page.subscriptionSuccess.exploreLink')}
        </Link>
      </div>
      <div className='description last'>{t('page.subscriptionSuccess.paragraph4')}</div>

      <MobileAppButtons className='mobile-app-buttons' />

      <div className='description'>{t('page.subscriptionSuccess.paragraph5')}</div>

      <h3 className='subtitle'>{t('page.subscriptionSuccess.needSomeMoreHelpTitle')}</h3>
      <div className='description'>
        {t('page.subscriptionSuccess.needSomeMoreHelpDescription')}
        <Link className='link' target='_blank' href={FOOTER_LINK.help}>
          {t('page.subscriptionSuccess.helpLink')}
        </Link>
      </div>
    </div>
  );
};
